// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".size-guide-wrapper[data-v-844d1e36]{border-radius:2rem;height:100%}.size-guide-wrapper.bras iframe[data-v-844d1e36]{height:705px;width:100%}.size-guide-wrapper.stockings iframe[data-v-844d1e36]{border-radius:1rem;height:400px;width:100%}@media screen and (min-width:1024px){.size-guide-wrapper.bras iframe[data-v-844d1e36]{height:760px}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
